<template>
    <div class="modal is-active">
        <div class="modal-background"></div>

        <div class="modal-card">

            <header class="modal-card-head">
                <p v-if="!isLoading && userData" class="modal-card-title">{{ userData.name }}</p>
            </header>
            <section class="modal-card-body">
                <base-spinner v-if="isLoading"></base-spinner>
                <div v-else-if="error" class="notification is-danger is-light">
                    {{ error }}
                </div>
                <div v-else-if="userData">
                    <table class="table is-fullwidth">
                        <tr>
                            <th>
                                Email
                            </th>
                            <td>
                                {{ userData.email }}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                Phone
                            </th>
                            <td>
                                {{ userData.phone }}
                            </td>
                        </tr>
                        <tr v-if="volunteerData">
                            <th>Location</th>
                            <td>{{ volunteerData.location }}</td>
                        </tr>
                    </table>

                    <div v-if="volunteerData && !(volunteerData.location === 'REDHILL' && volunteerData.role === 'DRIVER')" class="mb-4">
                        <button
                            class="button is-warning is-fullwidth"
                            :class="{ 'is-loading': isLocationButtonLoading }"
                            @click="changeLocation"
                        >
                            Move to {{ volunteerData.location === 'TBR' ? 'Redhill' : 'TBR' }}
                        </button>
                    </div>

                    <label class="checkbox">
                        <input type="checkbox" v-model="confirmRemove">
                        Confirm to Remove from sign-up list
                    </label>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button :disabled="!confirmRemove" @click="removeSignUp()" class="button is-danger"
                    :class="[isRemoveButtonLoading ? 'is-loading' : '']">Remove</button>
                <button @click="closePopup()" class="button">Cancel</button>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'userID', 'fdID'
    ],
    data() {
        return {
            isLoading: false,
            isRemoveButtonLoading: false,
            isLocationButtonLoading: false,
            error: null,
            confirmRemove: false,
            volunteerData: null,
        }
    },
    created() {
        this.loadUserData();
    },
    methods: {
        async loadUserData() {
            this.isLoading = true;
            try {
                await this.$store.dispatch('user/loadUserDataByID', this.userID);
                this.volunteerData = await this.$store.dispatch('volunteer/getUserRegistration', {
                    fdID: this.fdID,
                    userID: this.userID,
                });
            } catch (error) {
                this.error = error.message;
            }
            this.isLoading = false;
        },
        async removeSignUp() {
            this.isRemoveButtonLoading = true;
            try {
                await this.$store.dispatch('volunteer/removeVolunteerSignUp', {
                    fdID: this.fdID,
                    volunteerID: this.userID
                });
            } catch (error) {
                this.error = error.message;
            }
            this.isRemoveButtonLoading = false;
            this.closePopup();
        },
        async changeLocation() {
            this.isLocationButtonLoading = true;
            try {
                await this.$store.dispatch('volunteer/changeVolunteerLocation', {
                    fdID: this.fdID,
                    volunteerID: this.userID,
                    currentLocation: this.volunteerData.location,
                });
                this.volunteerData = {
                    ...this.volunteerData,
                    location: this.volunteerData.location === 'TBR' ? 'REDHILL' : 'TBR',
                    role: 'OTHER',
                };
            } catch (error) {
                this.error = error.message;
            }
            this.isLocationButtonLoading = false;
        },
        closePopup() {
            this.$emit('close-popup');
        }
    },
    computed: {
        userData() {
            return this.$store.getters['user/getUserData'];
        }
    }
}

</script>
